import { render } from "./PrivacyWarningDialog.vue?vue&type=template&id=0d40add4"
import script from "./PrivacyWarningDialog.vue?vue&type=script&lang=js"
export * from "./PrivacyWarningDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__